import { Button, Container, Form } from 'react-bootstrap';
import Banner from '../../Component/Banner';
import { useNavigate } from 'react-router-dom';

const PapaLadsEnd = () => {
    const navigate = useNavigate()

    const startQuiz = (e) => {
        e.preventDefault();
        navigate('/QuizTrivias/June2026/papaladsscoreboard')
    }

    return (
        <>
            <Container className="keiki-party papalads-70th">
            <div className='fontBackground'>
                <Banner caption="THANK YOU!"/>
            </div> 
            <div className='text-center'>
                <div className='Apps'>
                <div className="prim-results-card">
                    <h1 className="prim-score">
                        Score: {sessionStorage.getItem('PapaLadsTriviaScore')} / 10
                    </h1>

                    <h2 className="prim-time">
                        ⏱ Time: {sessionStorage.getItem('PapaLadsTriviaTime')} seconds
                    </h2>
                </div>
                
                <div className="papa-section-title">
                    Questions Review
                </div>

                <div className="papa-question-card">
                    Where was Ladz born?
                </div>
                <div className="papa-question-card">
                    What year did he graduate college?
                </div>

                <div className="papa-question-card">
                    Ladz is an alumni of Saint Louis University. What was his major?
                </div>

                <div className="papa-question-card">
                    Ladz worked in Saudi Arabia for decades. How many years before he retired?
                </div>

                <div className="papa-question-card">
                    What kind of work did he do?
                </div>

                <div className="papa-question-card">
                    Where did Ladz and Norly meet?
                </div>

                <div className="papa-question-card">
                    How long have they been married?
                </div>

                <div className="papa-question-card">
                    This is Ladz’s favorite song.
                </div>

                <div className="papa-question-card">
                    Including Ladz, how many siblings are there?
                </div>

                <div className="papa-question-card">
                    How many grandchildren do Ladz and Norly have?
                </div>
                    <br />
                <Form onSubmit={startQuiz}>
                    <br />
                    <div className='row'>
                        <div className='col'>
                        </div>
                        <div className='col align-self-center fontBackground'>
                        <Button
                            type="submit"
                            className="papa-scoreboard-btn"
                        >
                            Go to Scoreboard
                        </Button>
                        </div>
                        <div className='col'>
                        </div>
                        <br />
                    </div>
                </Form>
                </div>
            </div>
            </Container>
        </>
    )
}

export default PapaLadsEnd;